export function getNetworkInfo() {
  const connection = (navigator as any).connection || 
                     (navigator as any).mozConnection || 
                     (navigator as any).webkitConnection;

  if (!connection) {
    return {
      available: false,
      type: "unknown",
      effectiveType: "unknown",
      downlink: 0,
      rtt: 0,
      saveData: false,
    };
  }

  return {
    available: true,
    type: connection.type || "unknown", // wifi, cellular, ethernet, etc.
    effectiveType: connection.effectiveType || "unknown", // slow-2g, 2g, 3g, 4g
    downlink: connection.downlink || 0, // Mbps
    rtt: connection.rtt || 0, // Round-trip time in ms
    saveData: connection.saveData || false,
  };
}

